<template>
  <div>
    <b-row>
      <b-col>
        <h2>
          {{ trans((type == 'weekly' ? 'week' : 'month') + 's_available') }}
          <small class="text-muted">({{ numeral(totalRows).format('0,000')}})</small>
        </h2>
      </b-col>
      <b-col class="col-auto text-right">
        <b-button size="sm" variant="secondary" @click="onRefresh" :title="trans('refresh')" :disabled="busy">
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="weekly"
          ref="table"
          class="bg-white"
          bordered
          small
          responsive
          show-empty
          :items="provider"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template v-slot:empty>
            <p align="center">{{ trans('no_list_found') }}</p>
          </template>
          <template v-slot:cell(count)="data">
            <span v-if="data.item.import_running">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('importing') }}
              {{ importRunningCount(data.item) }}
            </span>
            <span v-if="!data.item.import_running">
              {{ data.value }}
            </span>
          </template>
        </b-table>
        <b-pagination
          :per-page="perPage"
          :current-page="currentPage"
          :total-rows="totalRows"
          v-model="currentPage"
          aria-controls="weekly"
          align="center"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: [
      'organization',
      'type', // weekly or monthly
    ],
    data() {
      return {
        trans: trans,
        numeral: numeral,
        moment: moment,
        error: null,
        busy: false,
        fields: [
          {key: 'yr', label: trans('year')},
          {
            key: this.type == 'weekly' ? 'week' : 'yr_mth',
            label: trans(this.type == 'weekly' ? 'week' : 'month'),
          },
          {
            key: 'start_date',
            label: trans('first_day'),
            formatter: (value, key, item) => {
              return moment(value).format('YYYY-MM-DD')
            },
          },
          {
            key: 'total_volume',
            label: trans('total_volume'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'total_spend',
            label: trans('total_spend'),
            formatter(value) {
              return numeral(value).format('0,000$')
            },
          },
          {
            key: 'fuel_visit',
            label: trans('fuel_visit'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'store_visit',
            label: trans('store_visit'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'fuel_mbrs',
            label: trans('fuel_mbrs'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'store_mbrs',
            label: trans('store_mbrs'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'new_members',
            label: trans('new_members'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'vol_by_visit',
            label: trans('vol_by_visit'),
            formatter(value) {
              return numeral(value).format('0,000.00')
            },
          },
          {
            key: 'spend_by_visit',
            label: trans('spend_by_visit'),
            formatter(value) {
              return numeral(value).format('0,000.00$')
            },
          },
          {
            key: 'vol_by_member',
            label: trans('vol_by_member'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
          {
            key: 'spend_by_member',
            label: trans('spend_by_member'),
            formatter(value) {
              return numeral(value).format('0,000.00$')
            },
          },
          {
            key: 'active_members',
            label: trans('active_members'),
            formatter(value) {
              return numeral(value).format('0,000')
            },
          },
        ],
        items: [],
        perPage: 5,
        currentPage: 1,
        totalRows: 0,
      }
    },
    methods: {
      onRefresh() {
        this.$refs.table.refresh()
      },
      provider() {
        this.error = null
        this.busy = true
        let url = `/organization/${this.organization.id}/datacandy/${this.type}/?page=${this.currentPage}&per_page=${this.perPage}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.perPage = response.data.per_page
          this.totalRows = response.data.total
          this.items = response.data.data
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.items = []
          return this.items
        })
      }
    },
    mounted() {
      window[this.type + 'Table'] = this
    },
  }
</script>